module.exports = __webpack_public_path__ + "static/media/phd_bosco_ndera1.9101f7e9.jpg";